import { FILENAME_SAFE_DATETIME_FORMAT } from '@/components/constants';
import { useCurrentTime } from '@/hooks/useCurrentTime';

export const useExportFileName = () => {
  const { getCurrentTime } = useCurrentTime();

  const getExportFileName = ({
    documentName,
    patientDemographicString,
  }: {
    documentName?: string | null;
    patientDemographicString?: string | null;
  }) => {
    return `${documentName ?? ''} ${patientDemographicString ?? ''} ${getCurrentTime(FILENAME_SAFE_DATETIME_FORMAT)}`.replace(
      /[/\n\\]/g,
      ''
    );
  };

  return {
    getExportFileName,
  };
};
